import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';
import { useScale } from '../../hooks/useScale';

const SettingsShellStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();
  const insets = useSafeAreaInsets();

  return useMemo(
    () =>
      StyleSheet.create({
        screen: {
          flex: 1,
          backgroundColor: colors.elevation0,
        },
        header: {
          padding: scale(16),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: colors.tertiary2,
          paddingTop: scale(16 + insets.top),
        },
        headerLeft: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        headerRight: {
          flexDirection: 'row',
          alignItems: 'center',
        },
        headerTitle: {
          color: colors.white,
          fontSize: scale(16),
          marginLeft: scale(12),
          fontFamily: theme.fonts.medium,
        },
        deviceBadge: {
          marginLeft: scale(12),
          paddingVertical: scale(4),
          paddingHorizontal: scale(10),
          borderRadius: theme.radius.s,
          backgroundColor: colors.tertiary3,
        },
        deviceBadgeText: {
          color: colors.white,
          fontSize: scale(12),
          fontFamily: theme.fonts.medium,
        },
        syncText: {
          color: colors.white,
          opacity: 0.6,
          fontSize: scale(12),
          marginRight: scale(12),
        },
        body: {
          flex: 1,
          flexDirection: 'row',
        },
        sidebar: {
          width: scale(240),
          paddingTop: scale(24),
          paddingHorizontal: scale(12),
          backgroundColor: colors.elevation1,
        },
        sidebarLabel: {
          fontSize: scale(11),
          color: colors.textLight,
          letterSpacing: scale(1),
          marginBottom: scale(12),
          paddingHorizontal: scale(12),
          textTransform: 'uppercase',
        },
        navItem: {
          paddingVertical: scale(12),
          paddingHorizontal: scale(12),
          marginBottom: scale(4),
          borderRadius: theme.radius.s,
        },
        navItemActive: {
          backgroundColor: colors.elevation2,
        },
        navItemText: {
          fontSize: scale(14),
          color: colors.textBody,
          fontFamily: theme.fonts.regular,
        },
        navItemTextActive: {
          color: colors.text,
          fontFamily: theme.fonts.medium,
        },
        sidebarFooter: {
          marginTop: 'auto',
          paddingVertical: scale(20),
          paddingHorizontal: scale(12),
        },
        footerLogo: {
          // Sits below the station lines, at the very bottom of the sidebar.
          marginTop: scale(16),
        },
        footerText: {
          fontSize: scale(11),
          color: colors.textLight,
          marginTop: scale(4),
        },
        content: {
          flex: 1,
        },
      }),
    [colors, insets, scale],
  );
};

export default SettingsShellStyles;
